import { PromoCodeCreatedBy, PromoCodeTag } from '../../../../../../services/exports/Constants';

export default {
  title: 'Códigos promocionales',
  tabs: {
    active: 'Activo',
    expired: 'Caducado',
    email_sign_up: 'Registro por email con promo',
  },
  show_master_promo_code: 'Mostrar código promocional maestro a los clientes',
  send_rejected_order_apologies_promo_code:
    'Enviar código promocional a clientes cuando el pedido es rechazado manualmente',
  filters: {
    tag: {
      placeholder: 'Etiqueta',
      options: {
        [PromoCodeTag.Master]: 'Maestro',
        [PromoCodeTag.Campaign]: 'Campaña',
        [PromoCodeTag.OneTime]: 'Un solo uso',
      },
    },
    code: {
      placeholder: 'Código',
    },
    campaign: {
      placeholder: 'Campaña',
    },
    created_by: {
      placeholder: 'Creado por',
      options: {
        [PromoCodeCreatedBy.User]: 'Usuario',
        [PromoCodeCreatedBy.System]: 'Sistema',
      },
    },
  },
  fields: {
    code: 'Código',
    tag: 'Etiqueta',
    type: 'Tipo',
    discount_type: 'Tipo de descuento',
    discount: 'Descuento',
    usage_threshold: 'Umbral de uso',
    quantity: 'Cantidad',
    expires_at: 'Vence',
    level: 'Nivel',
    max_discount: 'Descuento máximo',
    created_by: 'Creado por',
    image: 'Imagen',
  },
  tags: {
    [PromoCodeTag.Master]: 'Maestro',
    [PromoCodeTag.Campaign]: 'Campaña',
    [PromoCodeTag.OneTime]: 'Un solo uso',
  },
  types: {
    single_use: 'Uso único',
    multi_use: 'Uso múltiple',
    unknown: 'Desconocido',
  },
  discount_types: {
    fixed_amount: 'Importe fijo',
    percentage: 'Porcentaje',
    unknown: 'Desconocido',
  },
  created_by: {
    [PromoCodeCreatedBy.User]: 'Usuario',
    [PromoCodeCreatedBy.System]: 'Sistema',
  },
  labels: {
    discount: 'Descuento',
    usage_threshold: 'Umbral de uso',
    company: 'Empresa',
    restaurant: 'Restaurante',
    restaurant_group: 'Marca',
  },
  buttons: {
    add: 'Añadir',
    edit: 'Editar',
    delete: 'Eliminar',
    restore: 'Restaurar',
    add_promo_code: 'Añadir código promocional',
    images: 'Gestionar imagen',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    failed_to_save_settings: 'Error al guardar los cambios',
    failed_to_delete_promo_code: 'Error al eliminar el código promocional',
    failed_to_restore_promo_code: 'Error al restaurar el código promocional',
    promo_code_got_deleted: 'Código promocional eliminado',
    promo_code_got_restored: 'Código promocional restaurado',
  },
  delete_confirmation: {
    title: '¿Eliminar código promocional?',
    buttons: {
      yes: 'Sí',
      no: 'No',
    },
  },
  restore_confirmation: {
    title: '¿Restaurar código promocional?',
    buttons: {
      yes: 'Sí',
      no: 'No',
    },
  },
};
